export const defaultFormState = {
  name: '',
  male: '',
  female: '',
  unspecified_gender: '',
  unspecified_age: false,
  ageFrom: null as number | null,
  ageTo: null as number | null,
  geo: '',
  budget: '50',
  budget_usd_from: '50',
  budget_usd_to: '50',
  budget_base_currency: 'USD',
  headlines: '',
  descriptions: '',
  marketing_link: '',
  call_to_action: '',
  call_to_action_key: '',
  call_to_action_language: 'en-US',
  devices: [] as string[],
  append_tag: true,
  custom_utm: '',
  optimized_targeting: null as boolean | null,
  asset_automation_adaptive_layouts: null as boolean | null,
  asset_automation_generated_videos: null as boolean | null,
  source_image: [] as File[] | string[],
  marketing_image_formats: [] as string[],
  marketing_image: [] as File[] | [],
  marketing_image_square: [] as File[] | [],
  marketing_image_landscape: [] as File[] | [],
  marketing_image_portrait: [] as File[] | [],
  logo: [] as File[] | [],
  onNameChangeLogo: [],
  onNameChangeMarketingImage: [],
  onNameChangeMarketingImageSquare: [],
  onNameChangeMarketingImageLandscape: [],
  onNameChangeMarketingImagePortrait: [],
  tracking_template: '',
  final_url_suffix: '',
  custom_parameters: [] as { key: string; value: string }[],
  placements: {
    youtube_in_streams: false,
    youtube_in_feeds: false,
    youtube_shorts: false,
    gmail: false,
    discover: false,
    display: false,
  } as any,
};
